var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'timer-btn': true, disabled: !_vm.isClickable, timer: !!_vm.counter},on:{"click":_vm.getCode}},[_vm._v(" "+_vm._s(_vm.showTime || '获取验证码')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }